import { React, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { Button } from '../../../components/ui/legacy'

import CopyToClipboard from '../../../components/function/CopyToClipboard'
import IconHeading from '../../../components/ui/IconHeading'
import ConfirmationBox from '../../../components/ui/ConfirmationBox'
import { showErrorToast } from '../../../utils/showToast'
import { PATH } from '../../../data/router_path'
import { useNav } from '../../../hooks/useNav'
import useGetGuestAccountById from '../../../features/account-management/account-guest/hooks/useGetGuestAccountById'
import BookList from '../../../features/account-management/account-list/BookList'
import DeviceList from '../../../features/account-management/account-list/DeviceList'
const DetailGuestAccountPage = () => {
  const navigate = useNav()

  const { uuid: id } = useParams()

  const { data, isLoading } = useGetGuestAccountById(id)
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)

  const handleResetPassword = () => {
    showErrorToast({ message: 'Chưa được phát triển' })
    setIsConfirmationOpen(false)
  }

  if (isLoading) {
    return <div>Đang tải dữ liệu sinh viên...</div>
  }
  const guestInfo = [
    [
      { label: 'Mã người dùng:', value: data.id, hasCopy: true },
      { label: 'Tên tài khoản:', value: data.name },
    ],
    [
      { label: 'Email cá nhân:', value: data.personalEmail },
      { label: 'Số điện thoại:', value: data.phoneNumber },
    ],
  ]
  return (
    <div className="flex flex-col pb-12">
      <div className="flex-grow pb-12">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Icon
              className="global-icon cursor-pointer"
              icon="ph:arrow-left"
              onClick={() => navigate(PATH.ACCOUNT.GUEST.LIST)}
            />
            <div className="ml-2">
              <p className="font-medium">{data.id}</p>
              <p className="text-2xl font-bold">{data.name || '--'}</p>
            </div>
            <div className="ml-8">
              <div className="flex items-center space-x-2">
                {data.groups.slice(0, 3).map((group, index) => (
                  <span
                    key={index}
                    className={`rounded-full px-4 py-1 text-sm font-bold ${
                      group.name === 'Admin'
                        ? 'bg-blue-500 text-white'
                        : 'bg-gray-200'
                    }`}
                  >
                    {group.name}
                  </span>
                ))}
                {data.groups.length > 3 && (
                  <span className="rounded-full bg-gray-200 px-2 py-1 text-sm font-bold text-gray-800">
                    +{data.groups.length - 3}
                  </span>
                )}
              </div>
            </div>
          </div>
          {/* <Button
            variant="primary"
            onClick={() => navigate(PATH.ACCOUNT.GUEST.EDIT(data.uuid))}
          >
            Chỉnh sửa thông tin
          </Button> */}
          {/* <Button
            variant="primary"
            onClick={() => setIsConfirmationOpen(true)}
            className="rounded-xl"
          >
            Đặt lại mật khẩu
          </Button> */}
        </header>

        <section className="mt-4 flex w-full">
          <div className="mt-8 w-full">
            <IconHeading
              icon="ph:user"
              title="THÔNG TIN CÁ NHÂN"
              className="ml-2 text-lg"
            />
            <section className="mt-4 grid w-full gap-4">
              {guestInfo.map((row, index) => (
                <div key={index} className="grid grid-cols-2 gap-80">
                  {row.map((item, i) => (
                    <p
                      key={i}
                      className="flex items-center gap-1 text-sm font-light"
                    >
                      <span className="font-bold">{item.label}</span>
                      {item.value || '--'}
                      {item.hasCopy && <CopyToClipboard value={item.value} />}
                    </p>
                  ))}
                </div>
              ))}
              <BookList id={id} />
              <DeviceList />
            </section>
          </div>
        </section>
      </div>

      {/* <div className="flex justify-center pb-14">
        <Button
          variant="primary"
          onClick={() => setIsConfirmationOpen(true)}
          className="rounded-xl"
        >
          Đặt lại mật khẩu
        </Button>
      </div> */}
      {isConfirmationOpen && (
        <ConfirmationBox
          title="Xác nhận đặt lại mật khẩu ?"
          message="Mật khẩu sẽ trở về mật khẩu mặc định"
          onConfirm={handleResetPassword}
          onCancel={() => setIsConfirmationOpen(false)}
        />
      )}
    </div>
  )
}

export default DetailGuestAccountPage
